import { HStack, StackProps, VStack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { PublicNavbar } from "./PublicNavbar";

type Props = {
  pageTitle?: string;
  addon?: React.ReactNode;
  containerProps?: StackProps;
  logo?: string;
} & StackProps;

export const PublicLayout = ({
  children,
  addon,
  containerProps,
  pageTitle,
  logo,
  ...props
}: PropsWithChildren<Props>) => (
  <HStack w="full" h="full" alignItems="stretch" gap={0} {...props}>
    <VStack
      alignItems="flex-start"
      bgColor="black.50"
      flex={1}
      minH="100vh"
      {...containerProps}
    >
      <PublicNavbar title={pageTitle} logo={logo} />
      {children}
    </VStack>
  </HStack>
);
